import { render } from "./secondaryButton.vue?vue&type=template&id=42cd8cc4&scoped=true"
import script from "./secondaryButton.vue?vue&type=script&lang=js"
export * from "./secondaryButton.vue?vue&type=script&lang=js"

import "./secondaryButton.vue?vue&type=style&index=0&id=42cd8cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cd8cc4"]])

export default __exports__